<template>
  <modal :is-show="isShow" @hideModal="hideCopyModal">
    <div class="copy-modal">
      <div class="hd">
        <span v-if="!showBtn">复制失败，请长按选择复制</span>
        <span v-else>复制口令</span>
      </div>
      <textarea v-model="text" class="copy-text" />
      <button @click="handleCopy" class="copy-modal-btn" v-if="showBtn">一键复制口令</button>
    </div>
  </modal>
</template>

<script>
  import Modal from './Modal'
  import {mapMutations, mapState, mapActions} from 'vuex'
  export default {
    name: 'CopyModal',
    components: {
      Modal
    },
    computed: {
      ...mapState(['copyModalData']),
      isShow () {
        return this.copyModalData.isShow
      },
      text () {
        return this.copyModalData.text
      },
      showBtn () {
        return this.copyModalData.showBtn
      }
    },
    methods: {
      ...mapMutations(['hideCopyModal']),
      ...mapActions(['handleCopyAction']),
      handleCopy () {
        this.handleCopyAction({
          copyText: this.text
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .copy-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 5.8rem;
    height: 6.88rem;
    padding: 2.88rem .65rem 0 .73rem;
    border-radius: .18rem;
    background: url("//xwstatic.js571.com/2020/yh/618/gather/copy_pop.png") no-repeat;
    background-size: 5.8rem;
    transform: translate(-50%, -50%);
    .hd {
      height: .64rem;
      line-height: .64rem;
      text-align: center;
      margin-bottom: .1rem;
      font-size: .28rem;
      color: #d41b31;
    }
    .copy-text {
      width: 100%;
      height: 1.23rem;
      padding: .1rem .2rem;
      margin-bottom: .3rem;
      font-size: .28rem;
      line-height: 1.5;
      background: transparent;
      color: #f3eccf;
      text-align: center;
      resize: none;
      -webkit-appearance: none;
      box-sizing: border-box;
    }
    .copy-modal-btn {
      display: block;
      width: 4rem;
      height: 0.7rem;
      margin: 0 auto;
      color: #fff;
      font-size: 0.3rem;
      border-radius: 1rem;
      background: #f8b135;
      box-shadow: 0 0 0.2rem 0 #d68c0a;
    }
  }
</style>
